// api/API.js
import axios from "axios";

// const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:3000/api";
const API_BASE = process.env.REACT_APP_API_URL || "https://sepl.vicaas.in/api";

const api = axios.create({
  baseURL: API_BASE,
});

// CREATE (POST)
export const create = async (endpoint, payload, config = {}) => {
  const res = await api.post(endpoint, payload, config);
  return res.data;
};

// GET ALL (GET)
export const getAll = async (endpoint, params = {}) => {
  const res = await api.get(endpoint, { params });
  return res.data;
};

// GET by ID
export const getByID = async (endpoint, id, params = {}) => {
  const res = await api.get(`${endpoint}/${id}`, { params });
  return res.data;
};

// GET using a query string
export const getByQuery = async (endpoint, query) => {
  const res = await api.get(`${endpoint}?${query}`);
  return res.data;
};

// UPDATE / PATCH
export const update = async (endpoint, payload, config = {}) => {
  const res = await api.patch(endpoint, payload, config);
  return res.data;
};

// DELETE
export const remove = async (endpoint) => {
  const res = await api.delete(endpoint);
  return res.data;
};

export default api;
